import DepositForm from '../components/DepositForm';

const Deposit = () => {
    return (
        <DepositForm/>
    );
};

export default Deposit;